import React, { FC } from 'react'
import './CustomSkeletonLoader.scss'
import { CardBody, Icon, SkeletonLoader } from '@connectcore/connect-components-react'

export const CustomSkeletonLoader: FC<{}> = () => {
  return (
    <div className="CustomSkeletonLoader" data-testid="CustomSkeletonLoader">
      <div className="loader">
        <CardBody>
          <div className="px-3">
            <SkeletonLoader show={true} lineProps={{ width: '50%' }}>
              <p>Paragraph 1</p>
            </SkeletonLoader>
            <SkeletonLoader show={true}>
              <p>Paragraph 2</p>
            </SkeletonLoader>
            <SkeletonLoader show={true}>
              <p>Paragraph 3</p>
            </SkeletonLoader>
            <SkeletonLoader show={true}>
              <p>Paragraph 4</p>
            </SkeletonLoader>
            <SkeletonLoader show={true}>
              <p>Paragraph 5</p>
            </SkeletonLoader>
            <SkeletonLoader show={true}>
              <p>Paragraph 6</p>
            </SkeletonLoader>
            <SkeletonLoader show={true}>
              <p>Paragraph 7</p>
            </SkeletonLoader>
            <div
              className="row"
              style={{
                textAlign: 'end',
                display: 'flex',
                alignItems: 'end',
              }}
            >
              <div className="col d-flex">
                <SkeletonLoader
                  show={true}
                  lineProps={{
                    width: '30%',
                    height: '30px',
                    style: { margin: '0 auto', textAlign: 'end' },
                  }}
                >
                  <Icon name="connect" size="md" textPlacement="right" />
                </SkeletonLoader>
              </div>
            </div>
          </div>
        </CardBody>
      </div>
    </div>
  )
}

export default CustomSkeletonLoader
